import SelectWeekday from "@/views/crud/modules/SelectWeekday";
import timepicker from "@/views/crud/modules/timepicker";
import SelectPriceScheme from "@/views/custom/SelectPriceScheme";

export default {
    key: "charging_rate_detail",

    action: ["create","edit","delete"],
    default:{
        peak:"0"
    },
    filters:{
        chargingRateId:{}
    },
    fields: [
        {key: "id"},
        {key: "startTime", type:"componentColumn", component:timepicker },
        {key: "endTime", type:"componentColumn", component:timepicker },
        // {key :"fee"},
        {key :"peak", type:"boolean"},
        // {key :"point"},
        {key: "maxChargingUnit"},
        {key :"penaltyUnit",field:"penaltyUnit.name", value:"penaltyUnit.id", type:"select"},
        { key: "priceSchemeId", type: "componentColumn", component: SelectPriceScheme},
        // {key :"priceSchemeId",field:"priceSchemeId.name", value:"priceSchemeId.id", type:"select"},
        {key :"unit",field:"unit.name", value:"unit.id", type:"select"},
        {key :"penaltyFee"},
        {type: "action-btn", privilege: ["EDIT_CHARGING_RATE"]},
    ],
    options: {
        unit: {
            key: "charging_rate_unit",
            label: "name",
            value: "id",
        },
        penaltyUnit: {
            key: "charging_rate_unit",
            label: "name",
            value: "id",
        },
        priceScheme: {
            key: "priceScheme",
            label: "name",
            value: "id",
        },
    },
    structure:[
        ["startTime","endTime","peak"],
        // ["weekday"],
        ["unit","penaltyUnit"],
        // ["fee","penaltyFee"],
        // ["point","maxChargingUnit"],
        ["penaltyFee","maxChargingUnit"],
        ["priceSchemeId"],
        // ["priceSchemeDetail"],

        
    ]
}